import { apiDaInscricao } from './axios';

export const carregarCidadesDoEstado = async (uf: string) => {
  const { data: cidades } = await apiDaInscricao().get(`/cidades/BuscarPorUf/${uf}`);
  return cidades;
};